import * as yup from 'yup';
import { YSmsCodeValidate, YE164PhoneValidate } from '../yupValidators';
export const mfaPhoneSchema = yup.object({
  phone: YE164PhoneValidate
});
export const mfaSmsCodeInitialValues = {
  code: ''
};
export const mfaSmsCodeSchema = yup.object().shape({
  code: YSmsCodeValidate
});